import { render } from "./404.html.vue?vue&type=template&id=1c1f9b51"
import script from "./404.html.vue?vue&type=script&lang=js"
export * from "./404.html.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__